/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import moment from "moment";
import 'moment-timezone';
import React, { useContext, useEffect, useState } from "react";
import { Collapse, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Images from "../../Api/Images";
import wsSend_request from "../../Api/ws/ws_request";
import { WebSocketContext } from "../../App";
import Master from "../../assets/image/Master.svg";
import NotVerified from "../../assets/image/NotVerified.svg";
import RightDown from "../../assets/image/RightDown.svg";
import UserNotFound from "../../assets/image/UserNotFound.svg";
import Verified from "../../assets/image/Verified.svg";
import Visa from "../../assets/image/Visa.svg";
import cross_for_viewcard from "../../assets/image/cross_for_viewcard.svg";
import { ClearFormSetFutios } from "../../redux/actions/adminAction";
import CommonewModel from "../commonModel/commonModel";
import ReusableTable from "./ReusableTable";



const UserManagement = () => {
  const { websocket } = useContext(WebSocketContext);
  const { userList, search, listStatus, ClearFormSet} = useSelector((state) => state.adminReducers);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch()
  const [activeTableDetails, setActiveTableDetails] = useState("");
  const [viewModal, setViewModel] = useState({
    open: false,
    data: null,
  });  
    const handleOpen = (data) => {
    setViewModel({ open: true, data });
  };
    const handleClose = () => {
    setViewModel({ open: false, data:null });
  };

  const [showModalNew, setShowModalNew] = useState({
    open: false,
    title: "",
    modalType: "",
    Data: {}
});

  const currentFunction = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
  if (currentPage < 1) return;
  setCurrentPage(currentPage);
}, [currentPage]);

  useEffect(() => {
    callUserList()
  }, [websocket, currentPage, search, listStatus]);

 useEffect(() => {
    callUserList()
  }, []);

  function callUserList() {
    let param = {
      "transmit": "single",
      "url": "user_list",
      "request": {
        "status": listStatus === undefined || listStatus === "" ? "" : parseInt(listStatus),
        "limit": "20",
        "page_no": search ? 1 : currentPage,
        "search": search ? search : "",
        "order_by": "-updated_at",
        "user_type":"user"
      }
    }
    wsSend_request(websocket, param)
  }
  function handleSwitchChange(id, isChecked) {
    let param = {
      "transmit": "single",
      "url": "user_status_update",
      "request": {
        "status": isChecked,
        "user_id": id
      }
    }
    wsSend_request(websocket, param)
  }

  useEffect(() => {
    if (ClearFormSet?.url === "user_status_update" && ClearFormSet?.action === 200) {
      callUserList()
    }
    setTimeout(() => {
      dispatch(ClearFormSetFutios({
        url: "",
        action: ""
      }))
    }, 1000)
  }, [ClearFormSet, dispatch])

    const openModal = (Amt,user_id,status) => {
      setShowModalNew({
          ...showModalNew,
          open: !showModalNew?.open,
          title: "Create New Box",
          subtitle: "Create New Model",
          modalType: status,
          Data: {"Amt":Amt,"user_id":user_id}
      })
  };

  const ViewMoreDetails = (id) => {
    setActiveTableDetails(id);
  };

  const ElseMoreDetails = () => {
    setActiveTableDetails("");
  };
const headers = [
  { name: "", key: "" },
  { name: "User Id", key: "user_id" },
  { name: "Profile", key: "profile" },
  { name: "Full Name", key: "username" },
  { name: "Mobile Number", key: "phone" },
  { name: "Email Address", key: "email" },
  { name: "Verification", key: "verification" },
  { name: "Status", key: "status" },
  { name: "My Balance", key: "my_balance" },
  { name: "Withdraw Unutilized", key: "refund_utlize" },
  { name: "Assign Credit", key: "assignCredit" }
];
const cardList = [
  {
    cardNo: "**** **** **** 1234",
    expDate: "08/26",
    brand: "visa",
  },
  {
    cardNo: "**** **** **** 5678",
    expDate: "09/27",
    brand: "master_Card",
  },
  {
    cardNo: "**** **** **** 9876",
    expDate: "12/28",
    brand: "visa",
  },
];



  const renderRow = (user, index,visibleColumns) => {
    return(
    <React.Fragment key={user.id}>
      <tr className="user-management-table-detail">
        <td>
          <div style={{height:"15px",width:"10px",cursor:"pointer"}} onClick={() =>
              activeTableDetails === user.id
                ? ElseMoreDetails()
                : ViewMoreDetails(user.id)
            }>
            <img src={RightDown} style={{ objectFit: 'contain', height: "100%",  width: "100%", transform: activeTableDetails === user.id ? "rotate(90deg)" : "rotate(0deg)",transition: "transform 0.2s ease"}} alt="down"/>
          </div>
        </td>
       {visibleColumns?.includes('user_id') &&(<td className='Vertical_align'>{user.user_code || "-"}</td>)}
       {visibleColumns?.includes('profile') &&(<td className='Vertical_align'>
        <div>
        {user.avatar ? 
           <Images src={user?.avatar} height={20} width={20} alt="Avatar" />:
           <div style={{width:"20px",height:"20px"}}>
            <img src={UserNotFound}  className='w-100'/>
           </div>
        }
        </div>
       </td>)}
       {visibleColumns?.includes('username') &&(<td className='Vertical_align'>{user.username || "-"}</td>)}
       {visibleColumns?.includes('phone') &&<td className='Vertical_align'>{user.phone || "-"}</td>} 
       {visibleColumns?.includes('email') && <td className='Vertical_align'>{user.email || "-"}</td>} 
       {visibleColumns?.includes('verification') &&
        <td className='Vertical_align'>
        <div style={{ height:"24px",color: "black",background:user.is_verified ? "#B6EFBB":"#F7ABAB",borderRadius:"4px",padding:"5px",textAlign:"center" }}>
          {user.is_verified ? "Verified" : "Not Verified"}
        </div>
        </td>}
       {visibleColumns?.includes('status') &&(
        <td className='Vertical_align'>
          <Form.Check
            type="switch"
            id={`switch-${user.id}`}
            defaultChecked={user.is_active}
            className=''
            onChange={(e) => handleSwitchChange(user.id, e.target.checked)}
          />
        </td>)}
        {visibleColumns?.includes('my_balance') && <td className='Vertical_align'>{user.user_balance || "-"}</td>} 
        {visibleColumns?.includes('refund_utlize') && 
<td className="Vertical_align">
  {user.user_balance}
  {user.user_balance && user.user_balance_expire_date && " || "}
  {user.user_balance_expire_date ? moment(user.user_balance_expire_date).format("DD-MM-YYYY") : ""}
</td>
        } 

       {visibleColumns.includes('assignCredit') &&(
        <td
          title='Assign Credit'
          className='Vertical_align'
          style={{ color: "#1AA773", cursor: "pointer",textDecoration:"underline" }}
          onClick={() => openModal(user.user_balance, user.id, "Assign Credit")}
        >
          RM {parseFloat(user.user_balance).toFixed(2)}
        </td>)}
      </tr>
      <Collapse in={activeTableDetails === user.id}>
        <tr className="tablecollapsewraps" id={`collapse-${user.id}`}>
          <td colSpan={headers.length}>
                <div className="bg-light p-3 rounded" style={{ width: "100%" }}>
      <div className="bg-white rounded d-flex flex-wrap justify-content-between align-items-start gap-3">
        <div className="d-flex flex-column p-3" style={{ minWidth: "150px",height:"132px",flex: 1,borderRight:"2px solid #DCE3EC"  }}>
          <p className="fw-semibold mb-2 subdropdown_title">Document</p>
          <div className="d-flex gap-2">
              <Images src={user?.document_front} height={56} width={100} alt="Back" />
              <Images src={user?.document_back} height={56} width={100} alt="Back" />
          </div>
        </div>

        <div className="d-flex flex-column p-3" style={{ minWidth: "150px", height:"132px",flex: 1,borderRight:"2px solid #DCE3EC" }}>
        {user?.friend_number1 ?(
          <>
          <p className="fw-semibold mb-2 subdropdown_title">Friend 1 Mobile Number</p>
          <span className='number_title'>{user?.friend_number1} <span style={{color:user?.friend_number1_verified ?  "#2CBC87":"#E55757"}}><img src={user?.friend_number1_verified ?  Verified:NotVerified} alt="Verified"/> {user?.friend_number1_verified ?"Verified":"Not Verified"}</span></span>
          </>
        ):<p className="fw-semibold mb-2 subdropdown_title">Friend 1 Mobile Number Not Found</p>

        }
        </div>
        <div className="d-flex flex-column p-3" style={{ minWidth: "150px", height:"132px",flex: 1,borderRight:"2px solid #DCE3EC"  }}>
        {user?.friend_number2 ?(
          <>
          <p className="fw-semibold mb-2 subdropdown_title">Friend 2 Mobile Number</p>
          <span className='number_title'>{user?.friend_number2} <span style={{color:user?.friend_number2_verified ?  "#2CBC87":"#E55757"}}><img src={user?.friend_number2_verified ?  Verified:NotVerified} alt="Not Verified"/> {user?.friend_number2_verified ?"Verified":"Not Verified"}</span></span>
          </>
        ):<p className="fw-semibold mb-2 subdropdown_title">Friend 2 Mobile Number Not Found</p>

        }
        </div>

        <div className="d-flex flex-column p-3" style={{ minWidth: "250px", height:"132px",flex: 2}}>
          <div className="d-flex justify-content-between align-items-center">
            <p className="fw-semibold mb-2 subdropdown_title">Linked Cards</p>
            <h6 className="view_title" onClick={() => handleOpen(user)}>View All</h6>
          </div>
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded mb-2" style={{ height: "40px",}}>
            <span className='card_title'>Card No: **** **** **** 1234</span>
            <span className='exp_title'>Exp Date: 08/26</span>
            <img src={Visa} alt="Visa" style={{ width: "40px" }} />
          </div>
          <div className="d-flex justify-content-between align-items-center bg-light p-2 rounded" style={{ height: "40px",}}>
            <span className='card_title'>Card No: **** **** **** 1234</span>
            <span className='exp_title'>Exp Date: 08/26</span>
            <img src={Master} alt="Mastercard" style={{ width: "40px",}} />
          </div>
        </div>
      </div>
    </div>

          </td>
        </tr>
      </Collapse>
    </React.Fragment>
      
    )
};

  return (
    <>
      <ReusableTable
        headers={headers}
        data={userList?.list || []}
        height="150px"
        paginationObject={userList?.pagination}
        renderRow={renderRow}
        filters={{
         fromDate: false,
         toDate: false,
         period: false,
         search: true,
         searchPlaceholder: "Search by Full Name, User ID, Email, Mobile No",
         userSelect: false,
         userOptions: [],
         userActive: false,
         userOptionsForActive: [{ label: "All", value: "" },{ label: "Active", value: "1" },{ label: "Inactive", value: "0" }],
         reset:false,
         export: true
        }}
        currentPage={currentPage}
        handlePageChange={currentFunction}
        />
          {showModalNew?.open && (<CommonewModel setShowModalNew={setShowModalNew} showModalNew={showModalNew} />)}
          {viewModal?.open && (
            <div className="modal d-block" tabIndex="-1">
              <div className="modal-dialog modal-dialog-centered">
                <div
                  className="modal-content rounded-4"
                  style={{
                    width: "430px",
                    margin: "auto",
                    borderRadius: "17px",
                    border: "none",
                    boxShadow: "1px 1px 1px 0px #ffffff",
                    background:"#F7F8FC",
                    padding:"25px"
                  }}
                >
                  <div className="text-start">
                   <div className='d-flex justify-content-between align-items-center'>
                  <h1 className='view_popup_title'>Card Details</h1>
                  <img src={cross_for_viewcard} alt="cross_for_viewcard" className='cross_for_viewcard' onClick={handleClose}/>
                   </div>
                  <div className='mt-2'>
                   {cardList?.map((row)=>{
                    return(
                      <div className='d-flex p-2 w-100 bg-white mb-2 card_box'>
                       <div>
                        <img src={row?.brand==="visa" ?  Visa :Master} alt={row?.brand==="visa" ?  "Visa" :"Master"}/>
                       </div>
                       <div>
                        <h6>Card No: {row?.cardNo}</h6>
                        <span>Exp Date:: {row?.expDate}</span>
                       </div>
                      </div>
                    )
                   })}
                  </div>
                  </div>
                </div>
              </div>
            </div>
          )}
    </>
  );
};

export default UserManagement;
